import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * An indeterminate loading bar: a primary-colored segment that sweeps left to
 * right on a loop, indicating background activity. Purely visual — the consumer
 * shows/hides it (e.g. while API requests are in flight).
 *
 * @example
 * @if (loading()) { <fb-loading-bar /> }
 */
@Component({
  selector: 'fb-loading-bar',
  templateUrl: './loading-bar.html',
  styleUrl: './loading-bar.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    role: 'progressbar',
    'aria-label': 'Loading',
  },
})
export class LoadingBar {
  /** Height of the bar in pixels. */
  readonly height = input(15);

  /** Rounded (pill) ends; set false for a flush, full-width edge bar. */
  readonly rounded = input(true);
}
